import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/fp/debounce';
import { Spinner } from '@instructure/ui-spinner';
import t from '@instructure/quiz-i18n/format-message';
import { SELECT_EMPTY_OPTION, Select } from '@instructure/quiz-common';
export var GenericAsyncSearch = /*#__PURE__*/function (_Component) {
  function GenericAsyncSearch() {
    var _this2;
    _classCallCheck(this, GenericAsyncSearch);
    _this2 = _callSuper(this, GenericAsyncSearch, arguments);
    _defineProperty(_this2, "setInputRef", function (inputRef) {
      var _this2$props$inputRef, _this2$props;
      _this2.inputRef = inputRef;
      (_this2$props$inputRef = (_this2$props = _this2.props).inputRef) === null || _this2$props$inputRef === void 0 || _this2$props$inputRef.call(_this2$props, inputRef);
    });
    _defineProperty(_this2, "state", {
      inputValue: _this2.props.selectedOption ? _this2.props.selectedOption.text : '',
      isShowingOptions: false,
      isLoading: false,
      highlightedOptionId: null,
      shareableSubaccounts: [],
      options: []
    });
    _defineProperty(_this2, "handleShowOptions", function () {
      _this2.setState({
        isShowingOptions: true
      });
    });
    _defineProperty(_this2, "close", function (inputValue) {
      return _this2.setState({
        isShowingOptions: false,
        highlightedOptionId: null,
        inputValue: inputValue
      });
    });
    _defineProperty(_this2, "handleBlur", function () {
      var _this2$props$selected;
      return _this2.close(((_this2$props$selected = _this2.props.selectedOption) === null || _this2$props$selected === void 0 ? void 0 : _this2$props$selected.text) || '');
    });
    _defineProperty(_this2, "handleHighlightOption", function (event, optionIdentifier) {
      event.persist();
      var option = _this2.getOption(optionIdentifier.id);
      _this2.setState({
        highlightedOptionId: option === null || option === void 0 ? void 0 : option.id,
        inputValue: event.type === 'keydown' ? option === null || option === void 0 ? void 0 : option.text : _this2.state.inputValue
      });
    });
    _defineProperty(_this2, "handleSelectOption", function (event, optionIdentifier) {
      if (!optionIdentifier || !optionIdentifier.id || optionIdentifier.id === SELECT_EMPTY_OPTION) return;
      var option = _this2.getOption(optionIdentifier.id);
      _this2.props.onSelectionChange(event, option);
      _this2.close(option.text);
    });
    _defineProperty(_this2, "handleInputChange", function (event) {
      var value = event.target.value;
      var shouldSearch = !!value && value.length >= _this2.props.minChars;
      _this2.setState({
        inputValue: value,
        isShowingOptions: true
      });
      if (shouldSearch) {
        _this2.setState({
          isLoading: true,
          options: [],
          highlightedOptionId: null
        });
        _this2.search(value);
      }
    });
    _defineProperty(_this2, "handleKeyDown", function (event) {
      if (event.keyCode === 8 && _this2.state.inputValue === '') {
        // when backspace key is pressed
        _this2.setState({
          highlightedOptionId: null
        });
      }
    });
    _defineProperty(_this2, "actualOptions", function () {
      return _this2.state.options.map(function (option) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          id: option.id,
          key: option.id,
          isHighlighted: option.id === _this2.state.highlightedOptionId
        }, option.text);
      });
    });
    _defineProperty(_this2, "emptyOptionText", function () {
      if (_this2.props.minChars > 1 && _this2.state.inputValue < _this2.props.minChars) {
        return t('Search term must be at least { minChars } characters', {
          minChars: _this2.props.minChars
        });
      }
      return _this2.state.inputValue === '' ? t('Write to search') : t('No Results');
    });
    _defineProperty(_this2, "emptyOrLoadingOption", function () {
      return /*#__PURE__*/React.createElement(Select.Option, {
        id: SELECT_EMPTY_OPTION,
        key: SELECT_EMPTY_OPTION
      }, _this2.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading'),
        size: "x-small"
      }) : _this2.emptyOptionText());
    });
    _defineProperty(_this2, "renderOptions", function () {
      return _this2.state.options.length ? _this2.actualOptions() : _this2.emptyOrLoadingOption();
    });
    _this2.search = debounce(_this2.props.debounceDelay, function (value) {
      _this2.props.getOptions(value).then(function (options) {
        var _options$;
        _this2.setState({
          options: options,
          highlightedOptionId: ((_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.id) || null,
          isLoading: false
        });
      });
    });
    return _this2;
  }
  _inherits(GenericAsyncSearch, _Component);
  return _createClass(GenericAsyncSearch, [{
    key: "getOption",
    value: function getOption(queryId) {
      return this.state.options.find(function (_ref) {
        var id = _ref.id;
        return id === queryId;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Select, {
        "data-automation": this.props.selectAutomation,
        renderLabel: this.props.label,
        placeholder: this.props.placeholder,
        inputValue: this.state.inputValue,
        isShowingOptions: this.state.isShowingOptions,
        inputRef: this.setInputRef,
        onBlur: this.handleBlur,
        onRequestHideOptions: this.handleBlur,
        onInputChange: this.handleInputChange,
        onRequestShowOptions: this.handleShowOptions,
        onRequestHighlightOption: this.handleHighlightOption,
        onRequestSelectOption: this.handleSelectOption,
        onKeyDown: this.handleKeyDown,
        messages: this.props.messages,
        isRequired: this.props.isRequired
      }, this.renderOptions());
    }
  }]);
}(Component);
_defineProperty(GenericAsyncSearch, "propTypes", {
  debounceDelay: PropTypes.number,
  minChars: PropTypes.number,
  onSelectionChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  selectedOption: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string
  }),
  messages: PropTypes.array,
  selectAutomation: PropTypes.string,
  getOptions: PropTypes.func.isRequired,
  inputRef: PropTypes.func,
  isRequired: PropTypes.bool
});
_defineProperty(GenericAsyncSearch, "defaultProps", {
  debounceDelay: 500,
  minChars: 3,
  label: null,
  placeholder: null,
  selectAutomation: null,
  inputRef: function inputRef() {},
  isRequired: false
});
export default GenericAsyncSearch;